module.exports = __webpack_public_path__ + "img/image-text.c269b801.svg";